import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';
import Checkbox from './Checkbox';
import Spinner from './Spinner';
import EntryInfo from './EntryInfo';
import { logPageView, logEvent } from '../utils/analytics';
import fetch from 'isomorphic-unfetch';

const FilterTitle = styled.span`

`;

const Text = styled.span`

`;

const ModalWrap = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  z-index: 2;
  display: block;
  overflow-y: scroll;
  padding: 0 15px;
`;

const ModalContent = styled.div`
  margin: 45px auto 0 auto;
  width: 400px;
  padding: 30px;
  background-color: ${CONSTANTS.white};
  display: table;
  position: relative;
  border-radius: 3px;

  @media (max-width: 400px) {
    width: 100%;
    display: block
  };
`;

const ModalTitle = styled.h3`
  font-size: 24px;
  text-align: center;
  font-weight: 200;
`;

const ModalText = styled.p`
  font-size: 16px;
  text-align: left;
  padding-top: 10px;
  max-width: 450px;
  margin: 0 auto;
`;

const ModalClose = styled.button`
  position: absolute;
  right: -28px;
  top: -53px;
  color: ${CONSTANTS.white};
  font-size: ${CONSTANTS.closeModal};

  &:hover {
    ${CONSTANTS.hoverOpacity};
  }

  @media (max-width: 550px) {
    top: -59px;
    right: 0;
  };
`;

const InputEmail = styled.input`
  margin-top: 30px;
  font-size: ${CONSTANTS.headingTiny};
  width: 100%;
  display: block;
  margin-bottom: 10px;
  border: none;
  border: 1px solid ${CONSTANTS.uglyGray};
  padding: 10px 45px 10px 15px;
  border-radius: 3px;
`;

const Submit = styled.input`
  ${CONSTANTS.primaryCTA}

  &:hover {
    background-color: ${CONSTANTS.fakeCtaOpacity};
  }
`;

const TextInput = styled.input`
  outline: none;
  border-radius: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  font-size: ${CONSTANTS.headingTiny};
  width: 100%;
  display: block;
  margin-bottom: 10px;
  border: none;
  border: 1px solid ${CONSTANTS.uglyGray};
  padding: 10px 45px 10px 15px;
  border-radius: 3px;

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${CONSTANTS.uglyGray} inset;
    -webkit-text-fill-color: ${CONSTANTS.darkGray} !important;
  }

  &:focus {
    outline: none;
  }

  &.error {
    border-color: ${CONSTANTS.red} !important;
  }

  &::-webkit-input-placeholder {
    color: ${CONSTANTS.darkGray};
  }

  &:first-of-type {
    margin-top: 30px;
  }  
`;

const Screenshot = styled.img`
	margin: 10px auto 0 auto;
	display: block;
	border-radius: 3px;
  border: 1px solid #eee;
  max-width: 440px;
  cursor: zoom-in;
  width: 100%;

  @media (max-width: 550px) {
    cursor: default;
    pointer-events: none;
  };

  &.zoom {
    max-width: 768px;
    width: initial;
    cursor: zoom-out;

    @media (max-width: 960px) {
      max-width: 768px;
    };

    @media (max-width: 905px) {
      max-width: 600px;
    };

    @media (max-width: 745px) {
      max-width: 550px;
    };

    @media (max-width: 715px) {
      max-width: 520px;
    };

    @media (max-width: 680px) {
      max-width: 460px;
    };

    @media (max-width: 550px) {
      max-width: 420px;
      width: 100%;
    };
  }
`;

const EntryCTA = styled.a`
  ${CONSTANTS.primaryCTA}

  &:hover {
    background-color: ${CONSTANTS.fakeCtaOpacity};
  }
`;

const initialState = {
  showSpinner: false,
  newsletterModalTitle: 'Want more?',
  newsletterModalBody: `Subscribe to our monthly newsletter. We'll highlight a few recent sites, news, and updates.`,
  newsletterShowFormThings: true,
  submissionModalTitle: 'Be seen amongst the best',
  submissionModalBody: `If you'd like to have your site (or any site) considered for placement in our gallery, please complete the form below.`,
  submissionShowFormThings: true,
  modalData: {}
};

const Link = styled.a`

`;

const ModalHolder = styled.div`
  ${ModalContent} {
    ${props => (props.darkMode === true) ? `
    background-color: ${CONSTANTS.darkModeBackground};
    ` : ''}
  }

  ${ModalTitle} {
    ${props => (props.darkMode === true) ? `
    color: #fff;
    ` : ''}
  }

  ${ModalText} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeNiceGray};
    ` : ''}
  }

  ${ModalClose} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeNiceGray};
    ` : ''}
  }

  ${Submit} {
    ${props => (props.darkMode === true) ? `
    background-color: #1a1a1a;
    border-color: transparent;
    color: #fff;

    &:hover {
      background-color: #141414;
    }
    ` : ''}
  }

  ${InputEmail} {
    ${props => (props.darkMode === true) ? `
    background-color: ${CONSTANTS.darkModeBackground};
    border: 1px solid #242329;
    color: #fff;

    &::-webkit-input-placeholder {
      color: #fff;
    }
    ` : ''}
  }

  ${TextInput} {
    ${props => (props.darkMode === true) ? `
    background-color: ${CONSTANTS.darkModeBackground};
    border: 1px solid #242329;
    color: #fff;

    &::-webkit-input-placeholder {
      color: #fff;
    }
    ` : ''}
  }

  ${Link} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeWhite};
    ` : ''}
  }

  ${FilterTitle} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeWhite};
    ` : ''}
  }

  ${Text} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeWhite};
    ` : ''}
  }

  ${Screenshot} {
    ${props => (props.darkMode === true) ? 'border: 1px solid #242329' : ''};
  }

  ${EntryCTA} {
    ${props => (props.darkMode === true) ? `
    color: #fff;background-color: #1a1a1a; &:hover {background-color: #141414};
    ` : ''}
  }

  ${ModalWrap} {
    ${props => (props.darkMode === true) ? `
    background-color: rgba(47,47,47,0.7);
    ` : ''}
  }
`;

export default class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    this.closeModal = this.closeModal.bind(this);
    this.newsletterSubscription = this.newsletterSubscription.bind(this);
    this.siteSubmission = this.siteSubmission.bind(this);
    this.handleImageZoom - this.handleImageZoom.bind(this);
  }

  closeModal(e, location, name) {
    if(location === 'closeButton' || (location === 'overlay' && e.target.classList.contains('overlay')) ) {
      this.context.updateValue('currentModal', null);

      if(location === 'closeButton') {
        logEvent('modal close', `${name} | close button triggered`);
      } else {
        logEvent('modal close', `${name} | overlay triggered`);
      }

      logPageView(window.location.pathname);

      this.setState({ 
        ...initialState
      });
    }
  }

  newsletterSubscription(e) {
    e.preventDefault();

    if(!document.getElementById('newsletter-email').value || document.getElementById('newsletter-email').value == 'Please provide an email address'){
      document.getElementById('newsletter-email').value = `Please provide an email address`;
      return;
    } else if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(document.getElementById('newsletter-email').value)) {
      document.getElementById('newsletter-email').value = `Please provide a valid email address`;
      return;
    }

    this.setState({ 
      showSpinner: true,
    });
    
    if(!navigator.onLine) {
      this.setState({ 
        newsletterModalTitle: 'Network error',
        newsletterModalBody: 'Please check your connection and try again.',
        newsletterShowFormThings: false
      });

      this.setState({ 
        showSpinner: false,
      });

      return;
    }
    
    const subscriptionData = [{
      "email": document.getElementById('newsletter-email').value
    }];
    
    const fetchOptions = {
      method: 'POST',
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json"
      }, 
      body: JSON.stringify(subscriptionData)
    };
    
    fetch(CONSTANTS.SUBSCRIPTION_ENDPOINT, fetchOptions).then(function(response) {
      if(response.status && response.status === 200) {
        response.text().then(function(text) {
          switch(text) {
            case 'Successful email subscription':
              this.setState({ 
                newsletterModalTitle: 'Thanks!',
                newsletterModalBody: `We've just sent you a confirmation email.`,
                newsletterShowFormThings: false
              });

              break;
            case 'Email address invalid':
              document.getElementById('newsletter-email').value = `Please provide a valid email address`;
              break;       
            case 'Email address already subscribed':
              document.getElementById('newsletter-email').value = `Already subscribed`;
              break;
            case 'An email address was not provided':
              document.getElementById('newsletter-email').value = `Please provide an email address`;
              break;
            case 'Unspecified email subscription error':
              document.getElementById('newsletter-email').value = `Please try again`;
              break;
            default:
              this.setState({ 
                newsletterModalTitle: 'Thanks!',
                newsletterModalBody: `We've just sent you a confirmation email.`,
                newsletterShowFormThings: false
              });
          }
    
                    this.setState({ 
                        showSpinner: false,
                    });
    
                }.bind(this));
            }
      }.bind(this));
    }

    siteSubmission(e) {
        e.preventDefault();

        const isSubscribing = document.querySelector('#subscribeOrNot .checkbox-input').checked;
        
        const submissionData = [{
            "email": document.getElementById('submsn-email').value,
            "SiteURL": document.getElementById('submsn-url').value,
            "subscribe": isSubscribing
        }];
        
        if(!document.getElementById('submsn-email').value.length || !document.getElementById('submsn-url').value.length) {
            if(!document.getElementById('submsn-email').value.length) {
                document.getElementById('submsn-email').value = `Please provide an email address`;
            }
        
            if(!document.getElementById('submsn-url').value.length) {
                document.getElementById('submsn-url').value = `Please provide a site URL`;
            }
        
            return;
        }
        
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(document.getElementById('submsn-email').value)) {

        } else {
            document.getElementById('submsn-email').value = `Please provide a valid email address`;
            return;
        }
        
        if(!navigator.onLine) {
            this.setState({ 
                submissionModalTitle: 'Network error',
                submissionModalBody: 'Please check your connection and try again.',
                submissionShowFormThings: false
            });

            return;
        }

        this.setState({ 
            showSpinner: true,
        });
        
        const fetchOptions = {
            method: 'POST',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            }, 
            body: JSON.stringify(submissionData)
        };
        
        fetch(CONSTANTS.SUBMISSION_ENDPOINT, fetchOptions).then(function(response) {
            if(response.status && response.status === 200) {
                response.text().then(function(text) {   
                    switch(text) {
                        case 'Successful site submission':
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit');

                            break;       
                        case 'Successful site submission | Successful email subscription':
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit | with email subscription');

                            break;
                        case 'Successful site submission | Email address already subscribed':
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit | with email already subscribed');

                            break;
                        case 'Successful site submission | Email address invalid':
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit | with email address invalid');

                            break;
                        case 'Successful site submission | Unspecified email subscription error':
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit | with email subscription error');

                            break;
                        default:
                            this.setState({ 
                                submissionModalTitle: 'Thanks!',
                                submissionModalBody: 'If selected, your entry will be featured in our gallery within the next few days.',
                                submissionShowFormThings: false,
                            });

                            logEvent('submission', 'submit');
                    }

                    this.setState({ 
                        showSpinner: false,
                    });
                }.bind(this));
            }
        }.bind(this));
    }

    handleImageZoom(e) {
        e.preventDefault();
    
        if(e.target.classList.contains('zoom')) {
            e.target.classList.remove('zoom');
            logEvent('screenshot zoom', 'off');
        } else {
            e.target.classList.add('zoom');
            logEvent('screenshot zoom', 'on');
        }
    }

    render() {
        let modal = '';


        // TODO: use a switch statement?

        if(this.context.currentModal == 'newsletter') {
          
          logPageView('/subscribe');

          modal = (
            <ModalHolder darkMode={this.context.darkMode}>
                <ModalWrap onClick={(e) => this.closeModal(e, 'overlay', 'subscribe')} className="overlay">
                    <ModalContent>
                        <ModalTitle>{this.state.newsletterModalTitle}</ModalTitle>
                        <ModalText>{this.state.newsletterModalBody}</ModalText>

                        {this.state.newsletterShowFormThings ? (
                            <React.Fragment>
                                <InputEmail id="newsletter-email" type="text" autoComplete="off" placeholder="Your email address" name="email" />
                                <Submit type="submit" value="Submit" onClick={(e) => this.newsletterSubscription(e)} />
                            </React.Fragment>
                        ) : ''}

                        <Spinner isVisible={this.state.showSpinner} />
                        <ModalClose aria-label="Close window" onClick={(e) => this.closeModal(e, 'closeButton', 'subscribe')}>&times;</ModalClose>
                    </ModalContent>
                </ModalWrap>
            </ModalHolder>
          )
        } else if(this.context.currentModal == 'submission') {

          logPageView('/submit');

          modal = (
            <ModalHolder darkMode={this.context.darkMode} className="overlay">
                <ModalWrap onClick={(e) => this.closeModal(e, 'overlay', 'submit')} className="overlay">
                    <ModalContent>
                        <ModalTitle>{this.state.submissionModalTitle}</ModalTitle>
                        <ModalText>{this.state.submissionModalBody}</ModalText>
                        {this.state.submissionShowFormThings ? (
                            <React.Fragment>
                                <TextInput id="submsn-url" type="text" placeholder="Site URL" name="url" autoComplete="off" />
                                <TextInput id="submsn-email" type="text" placeholder="Your email address" name="email" autoComplete="off" />
                                <Checkbox id="subscribeOrNot" labelText="Subscribe to our newsletter" isChecked="true" isRound="true" />
                                <Submit type="submit" id="submit-site" value="Submit" onClick={(e) => this.siteSubmission(e)} />
                            </React.Fragment>
                        ) : ''}
                        <Spinner isVisible={this.state.showSpinner}/>
                        <ModalClose aria-label="Close window" onClick={(e) => this.closeModal(e, 'closeButton', 'submit')}>&times;</ModalClose>
                    </ModalContent>
                </ModalWrap>
            </ModalHolder>
          )
        } else if(this.context.currentModal == 'entry-details') {
          const { entryDetailsModalImg, entryDetailsModalOutobundUrl, entryDetailsModalShades, entryDetailsModalTags, entryDetailsModalTitle, entryDetailsModalUrlTitle, entryDetailsInboundUrl  } = this.context.modalData;

          logPageView(`${entryDetailsInboundUrl}?modal=1`);

          const tags = entryDetailsModalTags.split(',');
          const shades = entryDetailsModalShades.split(',');

          modal = (
            <ModalHolder darkMode={this.context.darkMode}>
                <ModalWrap onClick={(e) => this.closeModal(e, 'overlay', 'entry details')} className="overlay">
                    <ModalContent>
                        <ModalTitle>{entryDetailsModalTitle}</ModalTitle>
                        <Screenshot className="zoom" src={entryDetailsModalImg} alt="Screenshot" onClick={(e) => this.handleImageZoom(e)} />
                        <EntryInfo shades={shades} tags={tags} title={entryDetailsModalTitle} inboundUrl={entryDetailsInboundUrl} />
                        <EntryCTA aria-label={entryDetailsModalUrlTitle} href={entryDetailsModalOutobundUrl} target="_blank" rel="noopener noreferrer" onClick={event => logEvent('details modal CTA', 'click')}>{entryDetailsModalUrlTitle} →</EntryCTA>
                        <Spinner isVisible={this.state.showSpinner}/>
                        <ModalClose aria-label="Close window" onClick={(e) => this.closeModal(e, 'closeButton', 'entry details')}>&times;</ModalClose>
                    </ModalContent>
                </ModalWrap>
            </ModalHolder>
          )
        }

        return (
            modal
        )
    }
}

Modal.contextType = ModalContext;
